import { Button } from "@/components/ui/button";
import { DialogContent } from "@/components/ui/dialog";
import { MESSAGE } from "@/constants/message";
import { DatasetMetadata } from "@/types/dataset";

interface ConfirmationDialogProps {
  metadata?: DatasetMetadata;
  setOpen: (open: boolean) => void;
  handlePublishDataset: () => void;
  handleUnpublishDataset: () => void;
}

export default function ConfirmationDialog({
  metadata,
  setOpen,
  handlePublishDataset,
  handleUnpublishDataset
}: ConfirmationDialogProps) {
  const handleClickPublish = () => {
    if (metadata?.published) handleUnpublishDataset();
    else handlePublishDataset();
  };
  return (
    <DialogContent className="flex flex-col items-center gap-0" isHideClose>
      <h1 className="text-txtHeading text-xl font-semibold leading-7 mb-2">
        {metadata?.published ? "Unpublish Dataset?" : "Publish Dataset?"}
      </h1>
      <p className="text-txtBody text-center font-normal text-sm leading-[22px]">
        {metadata?.published
          ? MESSAGE.DATASET_MANAGEMENT_UNPUBLISH_DATASET_CONFIRMATION_DESCRIPTION
          : MESSAGE.DATASET_MANAGEMENT_PUBLISH_DATASET_CONFIRMATION_DESCRIPTION}
      </p>
      <div className="flex flex-row gap-3 w-full mt-6">
        <Button
          variant="outline"
          className="py-2.5 h-auto w-full rounded-xl font-semibold text-sm"
          onClick={() => setOpen(false)}
        >
          Cancel
        </Button>
        <Button
          variant="default"
          className="py-2.5 h-auto w-full rounded-xl font-semibold text-sm"
          onClick={handleClickPublish}
        >
          {metadata?.published ? "Unpublish" : "Publish"}
        </Button>
      </div>
    </DialogContent>
  );
}
